//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {toggleTopbar, switchNavColor, changeThemeColor,controlTopButton,  getCurrentThemeColor, getUserInfo, getVersionForAosAndIos} from '@/util/const'
// 这里注意具体看使用的版本是否需要引入样式，以及具体位置。
import 'swiper/swiper-bundle.css'
import {swiper, swiperSlide} from 'vue-awesome-swiper'

export default {
    name: "skinPreview",
    components: {
        swiper,
        swiperSlide
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.$swiper
        }
    },
    data() {
        return {
            swiperOption: {
                slidesPerView: 1.4,
                spaceBetween: 0,
                centeredSlides: true,
                watchSlidesProgress: true,
            },
            index: 0,
            oldIndex: 0,
            imgIndex: 0,
            title: '',
            imgList: [
                {src1: './static/img/skin/sy-zi.png', src2: './static/img/skin/tx-zi.png',src3: './static/img/skin/cj-zi.png'},//科技紫
                {src1: './static/img/skin/sy-z.png', src2: './static/img/skin/tx-z.png',src3: './static/img/skin/cj-z.png'},//（弃用）
                {src1: './static/img/skin/sy-l.png', src2: './static/img/skin/tx-l.png',src3: './static/img/skin/cj-l.png'},//能量绿
                {src1: './static/img/skin/sy-m.png', src2: './static/img/skin/tx-mh.png',src3: './static/img/skin/cj-mh.png'},//悦动玫红
                {src1: './static/img/skin/sy-lingxian.png', src2: './static/img/skin/tx-lingxian.png',src3: './static/img/skin/cj-lingxian.png'},//领先蓝
                {src1: './static/img/skin/cj-yuzhou.png'},//宇宙蓝
                {src1: './static/img/skin/slash1.png', src2: './static/img/skin/slash2.png',src3: './static/img/skin/slash3.png'}
            ],
            toast: false,
            isClick: true
        }
    },
    methods: {
        toastClick() {
            if(!this.isClick) return
            this.toast = true
        },
        checkData() {
            this.$Loading(true)
            this.$http.postOther('/v1/api/ad/startpage/updateThemeCount', {
                oldThemeId: this.oldIndex,
                newThemeId: this.index
            }).then(res => {
                this.isClick = false
                this.toast = false
                this.$Loading(false)
                if (res.data.header.resultCode === 0) {
                    changeThemeColor(this.index)
                    this.$toast({msg: this.$t('selectSkin.toast')})
                }else{
                    this.$toast({msg: this.$t('selectSkin.toast2')})
                }
            }).catch(err => {
                this.toast = false
                this.$Loading(false)
                this.$toast({msg: this.$t('selectSkin.toast2')})
            })
        },
    },
    created() {
        // 隐藏客户端状态栏
        toggleTopbar(0);
        // h5控制客户端导航栏字体颜色
        switchNavColor({color: 'FFFFFF'})
        let change = {
          backVisible: true,
        };
        controlTopButton(change);
        this.index = parseInt(this.$route.query.index)
        this.imgIndex = this.index - 1
        this.oldIndex = parseInt(this.$route.query.oldIndex)
        this.title = this.$route.query.title
        window.document.title = this.title
      if(this.$route.query.showStatus){
        this.imgList=[
          {src1: './static/img/skin/sy-zi.png', src2: './static/img/skin/tx-zi.png',src3: './static/img/skin/new-cj-zi.jpg'},
          {src1: './static/img/skin/sy-z.png', src2: './static/img/skin/tx-z.png',src3: './static/img/skin/new-cj-z.jpg'},
          {src1: './static/img/skin/sy-l.png', src2: './static/img/skin/tx-l.png',src3: './static/img/skin/new-cj-l.jpg'},
          {src1: './static/img/skin/sy-m.png', src2: './static/img/skin/tx-mh.png',src3: './static/img/skin/new-cj-mh.jpg'},
          {src1: './static/img/skin/sy-lingxian.png', src2: './static/img/skin/tx-lingxian.png',src3: './static/img/skin/new-lingxian2.jpg'},
          {src1: './static/img/skin/new-slash3.png'},
          {src1: './static/img/skin/slash1.png', src2: './static/img/skin/slash2.png',src3: './static/img/skin/new-cj-lingxian.png'}
        ]
      }
      //10.8区分imgList内容使用新的列表
      //AOS判断版本
      window.xxxMethod=(obj)=>{
        console.log('aos',Number(obj.replace(/\./g,'')))
        if(Number(obj.replace(/\./g,''))>=1080){
          this.imgList=[
            {src1: './static/img/skin/newImge1080/zi_src1.png', src2: './static/img/skin/newImge1080/zi_src2.png'},
            {src1: './static/img/skin/sy-z-new.png', src2: './static/img/skin/tx-z-new.png'},
            {src1: './static/img/skin/newImge1080/lv_src1.png', src2: './static/img/skin/newImge1080/lv_src2.png'},
            {src1: './static/img/skin/newImge1080/red_src1.png', src2: './static/img/skin/newImge1080/red_src2.png'},
            {src1: './static/img/skin/newImge1080/lxblue_src1.png', src2: './static/img/skin/newImge1080/lxblue_src2.png'},
            {src1: './static/img/skin/newImge1080/yzblue_src1.png',src2:'./static/img/skin/newImge1080/yzblue_src2.png'},
            {src1: './static/img/skin/slash1.png', src2: './static/img/skin/slash2.png',src3: './static/img/skin/new-cj-lingxian.png'}//slash用户
          ]
        }
      }
      let x=getVersionForAosAndIos({callbackName:'xxxMethod'})
      //ios判断版本
      if(x){
        console.log('ios',x)
        if(x>=1080){
          this.imgList=[
            {src1: './static/img/skin/newImge1080/zi_src1.png', src2: './static/img/skin/newImge1080/zi_src2.png'},
            {src1: './static/img/skin/sy-z-new.png', src2: './static/img/skin/tx-z-new.png'},
            {src1: './static/img/skin/newImge1080/lv_src1.png', src2: './static/img/skin/newImge1080/lv_src2.png'},
            {src1: './static/img/skin/newImge1080/red_src1.png', src2: './static/img/skin/newImge1080/red_src2.png'},
            {src1: './static/img/skin/newImge1080/lxblue_src1.png', src2: './static/img/skin/newImge1080/lxblue_src2.png'},
            {src1: './static/img/skin/newImge1080/yzblue_src1.png',src2:'./static/img/skin/newImge1080/yzblue_src2.png'},
            {src1: './static/img/skin/slash1.png', src2: './static/img/skin/slash2.png',src3: './static/img/skin/new-cj-lingxian.png'}//slash用户
          ]
        }
      }
    }
}



// WEBPACK FOOTER //
// ./src/page/selectSkin/skinPreview.vue